<template>
  <UIModalContainer
    :modal-show="modalShow"
    footer-classes="flex justify-end"
    :modal-width="50"
    @handleClick="onHandleClick"
  >
    <template v-slot:header>
      <span class="text-2xl text-label-text font-bold">{{ `${primaryRoleLabel} Birthdays` }}</span>
    </template>
    <template v-slot>
      <div v-if="users?.length" class="flex flex-col gap-4">
        <DetailCard
          v-for="(user, idx) in users"
          :key="`birthday-${idx}`"
          :details="getBirthdayDetails(user)"
          custom-classes="flex-col"
        />
      </div>
    </template>
    <template v-slot:footer>
      <div class="flex gap-3 rtl:gap-x-4">
        <UIButton @click="$emit('close')">Close</UIButton>
      </div>
    </template>
  </UIModalContainer>
</template>

<script>
import UIModalContainer from '@components/UiElements/UiModalContainer.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import DetailCard from '@src/components/UiElements/DetailCard.vue'
import GENERAL_CONSTANTS from '@src/constants/general-constants'
import { simplifiedRole } from '@src/utils/generalUtil.js'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'

export default {
  name: 'BirthdayModal',
  components: { UIModalContainer, UIButton, DetailCard },
  props: {
    modalShow: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['close'],
  data() {
    return {
      GENERAL_CONSTANTS,
      TENANT_ROLES,
    }
  },
  computed: {
    getPrimaryRoleEntity() {
      return (user = {}) => user?.users_roles_entities?.[0] || {}
    },
    primaryRoleLabel() {
      const roleId = this.getPrimaryRoleEntity(this.users?.[0])?.role_id
      const formattedRole = roleId ? this.simplifiedRole(roleId) : null
      return formattedRole || 'Users'
    },
    isTeacherOrStudent() {
      return (user) => {
        const roleId = this.getPrimaryRoleEntity(user)?.role_id
        return [TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.SECTION_STUDENT].includes(roleId)
      }
    },
  },
  methods: {
    simplifiedRole,
    getBirthdayDetails(user) {
      const details = {
        name: user?.full_name,
        dateOfBirth: user?.date_of_birth,
      }

      if (this.isTeacherOrStudent(user)) {
        const roleEntity = this.getPrimaryRoleEntity(user)
        details.class = roleEntity?.class?.name
        details.section = roleEntity?.section?.name
      }

      return details
    },
    onHandleClick(eventType) {
      if (eventType === 'close') {
        this.$emit('close')
      }
    },
  },
}
</script>
